/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Tagaicreation3Inputs */

const zh_showcase_tagaicreation3 = /** @type {(inputs: Showcase_Tagaicreation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI创作`)
};

const en_showcase_tagaicreation3 = /** @type {(inputs: Showcase_Tagaicreation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Creation`)
};

const es_showcase_tagaicreation3 = /** @type {(inputs: Showcase_Tagaicreation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creación IA`)
};

/**
* | output |
* | --- |
* | "AI Creation" |
*
* @param {Showcase_Tagaicreation3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_tagaicreation3 = /** @type {((inputs?: Showcase_Tagaicreation3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Tagaicreation3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_tagaicreation3(inputs)
	if (locale === "en") return en_showcase_tagaicreation3(inputs)
	return es_showcase_tagaicreation3(inputs)
});
export { showcase_tagaicreation3 as "showcase_tagAICreation" }